import { useState, useEffect, useContext, useMemo } from 'react';
import { SettingsContext } from '../../../contexts/Settings';
import { calulatePriceForMenu, getTax } from '../auth/pos/newpos/helpers';
import { getSystemSettings, getMerchantMenu, encryptAES128, handleKeenuTransaction, getOrCreateDeviceToken } from '../../../functions/Functions';
import { useGeneralHooks } from '../../../hooks/generalHooks';
import { useCustomHooks } from '../../../functions/Hooks';
import axios from 'axios';
import { BASE_URL } from '../../../BaseUrl';
import { ToastSuccess, ToastError } from '../../../functions/ToastShow';

export const getCustomerIp = (kitchenPrinterIp) => {
  if (!kitchenPrinterIp) return null;
  try {
    const parsed = typeof kitchenPrinterIp === "string" ? JSON.parse(kitchenPrinterIp) : kitchenPrinterIp;
    if (parsed && typeof parsed === "object") {
      const values = Object.values(parsed);
      return values.find(ip => !!ip) || null;
    }
    return typeof parsed === "string" ? parsed : null;
  } catch (e) {
    return typeof kitchenPrinterIp === "string" ? kitchenPrinterIp : null;
  }
};

export const groupKotItems = (orderItems = [], branch = {}) => {
  const kotObj = {};
  const consolidatedKot = branch && (branch.consolidated_kot === "true" || parseInt(branch.consolidated_kot) === 1);
  const branchKot = branch?.consolidated_ip;

  orderItems.forEach((obj) => {
    const kotKey = obj?.kot
      ? obj.kot === "No"
        ? "No"
        : (obj.kot_ip || "No")
      : (obj?.kot_ip || "No");
    const groupKey = obj?.groups?.name || "None";

    // branch wise consolidated kot
    if (consolidatedKot && branchKot) {
      if (
        kotObj.hasOwnProperty(branchKot) &&
        kotObj[branchKot] &&
        Object.keys(kotObj[branchKot])?.length
      ) {
        if (
          kotObj[branchKot].hasOwnProperty(groupKey) &&
          kotObj[branchKot][groupKey] &&
          kotObj[branchKot][groupKey]?.length
        ) {
          kotObj[branchKot] = {
            ...kotObj[branchKot],
            [groupKey]: [...kotObj[branchKot][groupKey], { ...obj }],
          };
        } else {
          kotObj[branchKot] = {
            ...kotObj[branchKot],
            [groupKey]: [{ ...obj }],
          };
        }
      } else {
        kotObj[branchKot] = {
          [groupKey]: [{ ...obj }],
        };
      }
    }

    if (obj?.is_special == "1" && obj?.properties && Array.isArray(obj.properties)) {
      obj.properties.forEach((prop) => {
        const propItem = {
          ...prop,
          name: `${obj.name} - ${prop.name || prop.property || ""}`,
        };

        if (
          kotObj[kotKey] &&
          kotObj.hasOwnProperty(kotKey) &&
          Object.keys(kotObj[kotKey])?.length
        ) {
          if (
            kotObj[kotKey].hasOwnProperty(groupKey) &&
            kotObj[kotKey][groupKey] &&
            kotObj[kotKey][groupKey]?.length
          ) {
            kotObj[kotKey] = {
              ...kotObj[kotKey],
              [groupKey]: [...kotObj[kotKey][groupKey], { ...obj, property: { ...propItem } }],
            };
          } else {
            kotObj[kotKey] = {
              ...kotObj[kotKey],
              [groupKey]: [{ ...obj, property: { ...propItem } }],
            };
          }
        } else {
          kotObj[kotKey] = {
            [groupKey]: [{ ...obj, property: { ...propItem } }],
          };
        }
      });
    } else {
      // item wise kot
      if (
        kotObj.hasOwnProperty(kotKey) &&
        kotObj[kotKey] &&
        Object.keys(kotObj[kotKey])?.length
      ) {
        if (
          kotObj[kotKey].hasOwnProperty(groupKey) &&
          kotObj[kotKey][groupKey] &&
          kotObj[kotKey][groupKey]?.length
        ) {
          kotObj[kotKey] = {
            ...kotObj[kotKey],
            [groupKey]: [...kotObj[kotKey][groupKey], { ...obj }],
          };
        } else {
          kotObj[kotKey] = {
            ...kotObj[kotKey],
            [groupKey]: [{ ...obj }],
          };
        }
      } else {
        kotObj[kotKey] = {
          [groupKey]: [{ ...obj }],
        };
      }
    }
  });

  return kotObj;
};

export const useDigitalMenuLogics = (id, tableName, orderType) => {
  const { generalSettings } = useContext(SettingsContext);
  const { taxType } = useGeneralHooks();
  const { roundOffPrice, getDynamicOfflinePrintUrl } = useCustomHooks();
  
  const [orderDetail, setOrderDetail] = useState({
    header_text: "",
    link_text: "",
    links: [],
    terms_conditions: "",
    footer_desc: "",
    branch: "",
    table: "",
    payment_type: null,
    newCustomerInfo: {
      name: "",
      phn_no: ""
    },
    menu: {
      id: null,
      name: ""
    }
  });
  
  const [rawMenuData, setRawMenuData] = useState({});
  const [popularItems, setPopularItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customerOrder, setCustomerOrder] = useState(null);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [isBranchConfirmModalOpen, setIsBranchConfirmModalOpen] = useState(false);
  const [isCardPaymentModalOpen, setIsCardPaymentModalOpen] = useState(false);
  const [cardPaymentStep, setCardPaymentStep] = useState('tap_card');

  // Cart state
  const [cartItems, setCartItems] = useState({});
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [instructionModalState, setInstructionModalState] = useState({ isOpen: false, item: null });

  // Totals
  const [cartSubTotal, setCartSubTotal] = useState(0);
  const [cartTax, setCartTax] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);

  const handleUpdateCustomerInfo = (name, phn_no) => {
    setOrderDetail(prev => ({
      ...prev,
      newCustomerInfo: { name, phn_no }
    }));
    if(!orderDetail.table?.id){
      fetchCustomerOrder(orderDetail.branch.id, "", orderDetail.newCustomerInfo?.phn_no ?? phn_no ?? "")
      try {
        localStorage.setItem("cusotmer_info", JSON.stringify({ name, phn_no }));
      } catch (error) {
        console.error("Error setting customer info in localStorage:", error);
      }
    }
  };

  const checkCustomerOrder = () => {
    if (tableName?.toLowerCase() !== "takeaway") return false;
    try {
      return !!JSON.parse(localStorage.getItem("cusotmer_info"))?.phn_no;
    } catch {
      return false;
    }
  };

  const fetchMenuData = async () => {
    setLoading(true);
    const token = getSystemSettings(generalSettings, "sales_listing_key");
    const a = "M3rch"
    const b = "@nt24"
    const c = "#Menu!"
    const secretKey = a + b + c;
    const data = await getMerchantMenu(token, secretKey, id, tableName, orderType);
    if (data) {
      if(data?.menu){
        setRawMenuData(data.menu);
      }
      if(data?.popular_items) {
        setPopularItems(data.popular_items);
      }
      if(data?.branch_menu_description){
        const branchId = data.branch_menu_description?.branch_id;
        const tableId = data?.table?.id;

        if (tableId && branchId) {
          getOrCreateDeviceToken(branchId);
        }
        
        setOrderDetail({
          header_text: data.branch_menu_description.header_text || "",
          link_text: data.branch_menu_description.link_text || "",
          links: data.branch_menu_description.links || [],
          terms_conditions: data.branch_menu_description.terms_conditions || "",
          footer_desc: data.branch_menu_description.footer_desc || data.branch_menu_description.footer_description || "",
          branch: {
            id: branchId ?? "",
            name: data.branch_menu_description?.branch_name ?? "",
            branch_tax: data.branch_menu_description?.branch_tax ?? 0,
            payment_tax: data.branch_menu_description?.payment_tax ?? {},
            is_self_ordering: data.branch_menu_description?.branch_self_order ?? 0,
            // Default to visible for older API responses that predate this setting.
            dm_image_display: Boolean(data.branch_menu_description?.dm_image_display ?? 1),
            consolidated_kot: data.branch_menu_description?.consolidated_kot ?? 0,
            consolidated_ip: data.branch_menu_description?.consolidated_ip ?? "",
            customer_counter_ip: data.branch_menu_description?.customer_counter_ip ?? "",
            kitchen_printer_ip: data.branch_menu_description?.kitchen_printer_ip ?? "",
            print_tax: data.branch_menu_description?.print_tax ?? 0,
            qsr_card_payment: Boolean(data.branch_menu_description?.qsr_card_payment ?? 0),
            show_addon_image: Boolean(data.branch_menu_description?.dm_addon_image_display ?? 1),
          },
          menu: {
            id: data.branch_menu_description?.menu_id ?? null,
            name: data.branch_menu_description?.menu_name ?? ""
          },
          table: data?.table || "",
          payment_type: data?.payment_type ?? data?.branch_menu_description?.payment_type ?? null,
        });

        
        if (branchId && (tableId || checkCustomerOrder())) {
          let phn_no = "";
          if (tableId) {
            setTimeout(() => {
              setIsBranchConfirmModalOpen(true);
            }, 0);
          }
          try {
            phn_no = JSON.parse(localStorage.getItem("cusotmer_info"))?.phn_no ?? "";
          } catch (error) {
            console.error("Error reading customer info from localStorage:", error);
          }
          fetchCustomerOrder(branchId, tableId, phn_no);
        }
      }
    }
    setLoading(false);
  };

  const fetchCustomerOrder = async (branchId, tableId, phoneNum) => {
    const token = getSystemSettings(generalSettings, "sales_listing_key");
    const a = "M3rch"
    const b = "@nt24"
    const c = "#Menu!"
    const secretKey = a + b + c;
    const encryptedToken = await encryptAES128(token, secretKey);
    try {
      const url = BASE_URL + "/settings/view-customer-order";
      const payload = {
        branch_id: branchId,
        table_id: tableId,
        device_token: getOrCreateDeviceToken(branchId),
        token: encryptedToken,
        customer_phone: !tableId ? (phoneNum || "") : ""
      };
      const response = await axios.post(url, payload);
      if(response?.data) {
        setCustomerOrder(response.data);
        if(response.data?.customer_name){
          setOrderDetail((curr)=>({
            ...curr,
            newCustomerInfo: {
              name: response.data?.customer_name, 
              phn_no: response.data?.customer_phone
            }
          }))
          setIsCustomerModalOpen(false);
        }
      }
    } catch (error) {
      console.error("Error fetching customer order:", error);
      if (error?.response?.data?.status === 0 && error.response?.status === 500) {
        setCustomerOrder(null);
      }
    }
  };

  useEffect(() => {
    if(!generalSettings) return;
    fetchMenuData();
  }, [id, tableName, orderType, generalSettings]);

  const getPaymentTaxRate = () => {
    let paymentTax = orderDetail.branch?.payment_tax;

    const paymentType = orderDetail.payment_type || orderDetail.branch?.payment_type;
    const paymentTypeName = paymentType?.name || (Array.isArray(paymentType) ? paymentType[0]?.name : null);

    if (orderType && orderDetail.branch?.qsr_card_payment && paymentTax && typeof paymentTax === 'object' && paymentTypeName) {
      let bTax = paymentTax[paymentTypeName];
      if (bTax && !isNaN(parseFloat(bTax))) {
        return parseFloat(bTax);
      }
    }
    return parseFloat(orderDetail.branch?.branch_tax ?? 0);
  };

  const getBeforeTaxPrice = (price) => {
    const taxRate = getPaymentTaxRate();
    if (taxType === "inclusive") {
      return price / (1 + (taxRate / 100));
    }
    return price;
  };

  // Handle Cart calculations efficiently in a single loop
  useEffect(() => {
    const taxRate = getPaymentTaxRate();
    const subTotalAcc = Object.values(cartItems).reduce((sum, item) => sum + item.sub_total, 0);
    const tax = getTax(taxRate, subTotalAcc);

    setCartSubTotal(roundOffPrice(subTotalAcc));
    setCartTax(roundOffPrice(tax));
    setCartTotal(roundOffPrice(subTotalAcc + tax));
  }, [cartItems, orderDetail.payment_type]);

  const generateCartHashId = (item, variation, properties) => {
    let id = item.id || item.name;
    if (variation) {
      id += `-${variation.food_with_variation_id}`;
    }
    if (properties && item?.has_property === "1" && properties.length > 0) {
      id += properties.map((item)=> item.id + (item?.quantity ?? "")).join("")
    }
    return id;
  };

  const handleAddToCart = (item, variation = null, properties = {}, qty = 1, comments = "") => {
    const id = generateCartHashId(item, variation, properties);
    const existing = cartItems[id];

    if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && !item?.is_recipe && item?.is_deal === 0) {
      const checkStock = item?.available_qty ?? 0;
      const currentQty = existing ? existing.quantity : 0;
      if (currentQty + qty > checkStock) {
        ToastError({ title: "Stock limit has been exceed", position: "top-right", toastId: "stock-limit" });
        return;
      }
    }

    setCartItems(prev => {
      const existingPrev = prev[id];
      if (existingPrev) {
        const updatedItem = {
          ...existingPrev,
          quantity: existingPrev.quantity + qty
        };
        if (comments) updatedItem.comments = comments; // update comments if any new provided
        const price = roundOffPrice(getBeforeTaxPrice(calulatePriceForMenu(updatedItem, updatedItem.quantity)))
        return {
          ...prev,
          [id]: {
            ...updatedItem,
            sub_total: price
          }
        };
      } else {
        const newItem = {
          id: item.id,
          name: item.name,
          price: item.price,
          image: item.image,
          cost_price: item?.cost_price ?? 0,
          has_variation: item?.has_variation ?? 0,
          has_property: item?.has_property ?? 0,
          comments: comments,
          groups: item?.groups ?? [],
          is_loyalty: item?.is_loyalty ?? 0,
          quantity: qty,
          variation: variation,
          properties: properties,
          kot: item?.kot,
          kot_ip: item?.kot_ip,
        };
        
        const price = roundOffPrice(getBeforeTaxPrice(calulatePriceForMenu(newItem, qty)));

        return {
          ...prev,
          [id]: {
            ...newItem,
            sub_total: price
          }
        };
      }
    });
  };

  const handleRemoveFromCart = (item) => {
    setCartItems(prev => {
      const id = generateCartHashId(item, item?.variation, item?.properties);
      const existing = prev[id];
      if (!existing) return prev;
      if (existing.quantity === 1) {
        const newCart = { ...prev };
        delete newCart[id];
        return newCart;
      } else {
        const newQty = existing.quantity - 1;
        const updatedItem = { ...existing, quantity: newQty };
        const newSubTotal = roundOffPrice(getBeforeTaxPrice(calulatePriceForMenu(updatedItem, newQty)));
        
        return {
          ...prev,
          [id]: {
            ...updatedItem,
            sub_total: newSubTotal
          }
        };
      }
    });
  };

  const handleUpdateInstruction = (cartItem, comment) => {
    setCartItems(prev => {
      const id = generateCartHashId(cartItem, cartItem?.variation, cartItem?.properties);
      const existing = prev[id];
      if (!existing) return prev;
      return {
        ...prev,
        [id]: {
          ...existing,
          comments: comment
        }
      };
    });
  };

  const handleEmptyState = () =>{
    setInstructionModalState({ isOpen: false, item: null });
    // Optionally clear cart items here
    setCartItems({});
    setIsCartOpen(false);
  }

  const handleDirectPrint = async (data) => {
    const fbrNum = data?.fbr_invoice_num || data?.fbr_pos_invoice_no || "";
    const srbNum = data?.srb_pos_invoice_no || "";
    const srbQrUrl = data?.srb_pos_qr_url || "";
    const orderId = data?.order_group_id || data?.id || null;

    const itemsList = Object.values(cartItems)

    const firstCustomerIp = getCustomerIp(orderDetail.branch?.kitchen_printer_ip);
    const deliveryPrinterIp = (orderDetail.branch?.customer_counter_ip && orderDetail.branch.customer_counter_ip !== "")
      ? orderDetail.branch.customer_counter_ip
      : null;

    const printDeliveryIp = deliveryPrinterIp || firstCustomerIp || null;
    const printCustomerIp = firstCustomerIp || deliveryPrinterIp || null;

    const kotItems = groupKotItems(itemsList, orderDetail.branch);

    const formData = {
      site_name: getSystemSettings(generalSettings, "siteName"),
      branch: orderDetail.branch,
      type_print_heading: getSystemSettings(generalSettings, "type_print_heading"),
      party_name: orderType,
      partyDetails: { partyName: orderType },
      guest: 1,
      isSettle: 1,
      table: orderDetail.table,
      waiter: null,
      dept_tag: null,
      loyalty_points: 0,
      payment_type: [],
      payment_amount: 0,
      card_number: null,
      newCustomerInfo: orderDetail.newCustomerInfo,
      token: {
        id: data?.token_no || data?.token || orderId,
        invoice_no: data?.invoice_no || fbrNum || "",
        time: new Date().toLocaleString(),
        order_id: orderId
      },
      total_guest: 1,
      table_id: orderDetail.table?.id || null,
      table_name: orderDetail.table?.name || "",
      discount_voucher: null,
      tax_type: taxType,
      fixed_tax_type: parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1,
      rider_name: "",
      rider_notes: "",
      feedback_url: "",
      deliveryIp: printDeliveryIp,
      customerIp: printCustomerIp,
      is_online: 1,
      is_self_order: 1,
      customerOrder: itemsList,
      orderItems: kotItems,
      serviceCharge: 0,
      service_amount: 0,
      order_tip: 0,
      discount: 0,
      scheme: null,
      subTotal: cartSubTotal,
      totalPayable: cartTotal,
      view_cash_card: parseInt(getSystemSettings(generalSettings, "view_cash_card")),
      cash: 0,
      card: 0,
      cash_percent: 0,
      card_percent: 0,
      paidMoney: 0,
      theVat: cartTax,
      tax_percent: getPaymentTaxRate(),
      print_tax: orderDetail.branch?.print_tax ?? "Tax",
      dept_commission: 0,
      workPeriod: null,
      order_id: orderId,
      orderTypeDetails: { orderTypeName: orderType },
      orderFoodGroups: [],
      selectedPropertyGroup: [],
      propertyGroupForSearch: [],
      RefNo: "",
      return_amount: 0,
      print_footer: getSystemSettings(generalSettings, "type_print_footer"),
      print_bill_footer: getSystemSettings(generalSettings, "print_bill_footer"),
      kot_header: getSystemSettings(generalSettings, "kot_header"),
      user_name: "Customer",
      user_type:"Self",
      fbr_num: fbrNum,
      srb_num: srbNum,
      srb_qr_url: srbQrUrl,
    };

    const offlinePrintUrl = (getDynamicOfflinePrintUrl && getDynamicOfflinePrintUrl("/example-app/api/test")) || 
      ("http://localhost:8081" + "/example-app/api/test");

    try {
      await axios.post(offlinePrintUrl, formData, {
        headers: { "Content-Type": "application/json" },
        timeout: 10000,
      });
    } catch (printErr) {
      console.error("Print error:", printErr);
    } finally {
      handleEmptyState();
    }
  };

  const handlePlaceOrder = async () => {
    if (isNaN(cartTotal)) {
      ToastError({ title: "Total amount can't be NaN", position: "top-right", toastId: "nan-error" });
      return false;
    }

    const isCustomerValidation = parseInt(getSystemSettings(generalSettings, "dm_customer_validation")) === 1;

    if (isCustomerValidation && !orderDetail.newCustomerInfo?.name) {
      setIsCustomerModalOpen(true);
      return false;
    }
    
    setLoading(true);
    const currentTime = new Date().getTime();
    const token = getSystemSettings(generalSettings, "sales_listing_key");
    const a = "M3rch"
    const b = "@nt24"
    const c = "#Menu!"
    const secretKey = a + b + c;

    const encryptedToken = await encryptAES128(token, secretKey)
    
    // In payload, token.time replaces the old token prop which we will override with the encrypted token in Functions.js.
    // However, since Functions.js spreads payload, we'll nest this as 'order_time' or similar if needed. But let's stick to the original payload structure.
    const deviceToken = getOrCreateDeviceToken(orderDetail?.branch?.id, Boolean(orderType));
    let paymentResponse = "";
    if(orderType && orderDetail.branch?.qsr_card_payment){
      setCardPaymentStep('tap_card');
      setIsCardPaymentModalOpen(true);
      try {
        paymentResponse = await handleKeenuTransaction(deviceToken, orderDetail?.branch, cartTotal.toFixed(2), deviceToken, "");
      } catch (err) {
        console.error("Card payment error:", err);
        setIsCardPaymentModalOpen(false);
        setLoading(false);
        return false;
      }
    }
    if (paymentResponse) {
      const integrationRes = paymentResponse;
      if ((integrationRes?.response !== "APPROVED" && integrationRes !== "APPROVED") || integrationRes?.error) {
        setIsCardPaymentModalOpen(false);
        setLoading(false);
        return false;
      }
      setCardPaymentStep('processing');
    }
    const payload = {
      branch: orderDetail?.branch,
      menu_id: orderDetail.menu.id,
      menu_name: orderDetail.menu.name,
      device_token: deviceToken,
      total_guest: 1,
      table: orderDetail?.table,
      customer_name: orderDetail.newCustomerInfo?.name ?? "",
      customer_phone: orderDetail.newCustomerInfo?.phn_no ?? "",
      time: currentTime,
      token: encryptedToken,
      order_bill: cartSubTotal,
      vat: cartTax,
      total_payable: cartTotal,
      orderItems: Object.values(cartItems),
      ...(orderType && { 
        order_type: orderType,
        payment_type: [{...orderDetail.payment_type, tax_percent: getPaymentTaxRate(), tax_amount: cartTax, bill_amount: cartTotal, payment_integration: paymentResponse?.success ? paymentResponse.data : paymentResponse.error }]
      }),
    };

    
    try {
      const url = BASE_URL + "/settings/digital-menu-new-order";
      const response = await axios.post(url, payload);
      const data = response.data;
      
      setLoading(false);
      setIsCardPaymentModalOpen(false);
      
      if (data && (data?.order_group_id || data?.status === 1 || data?.id)) {
        ToastSuccess({ title: "Order Placed Successfully!", position : "top-right", toastId: "order-placed-success" });

        if (orderType) {
          await handleDirectPrint(data);
        } else {
          if(parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1){
            fetchMenuData();
          } else if (orderDetail?.branch?.id && (orderDetail?.table?.id || checkCustomerOrder())) {
            fetchCustomerOrder(orderDetail.branch.id, orderDetail.table?.id, orderDetail.newCustomerInfo?.phn_no ?? "");
          }
          handleEmptyState();
        }
      } else {
        ToastError({ title: "Failed to place order.", position : "top-right", toastId: "order-placed-failed" });
      }
    } catch (error) {
      console.error(error);
      setIsCardPaymentModalOpen(false);
      setLoading(false);
      if(error.response?.data?.status === 0){
        ToastError({ title: error.response.data?.message, position : "top-right", toastId: "order-placed-error-msg" });
        return;
      }
      ToastError({ title: "Failed to place order.", position : "top-right", toastId: "order-placed-failed-general" });
    }
  };

  // Convert object format { "Category": [items] } into array for easier rendering
  const menuData = useMemo(() => {
    return Object.entries(rawMenuData).map(([name, items], index) => ({
      id: `${name}-${index}`,
      name: name,
      items: items
    }));
  }, [rawMenuData]);

  return {
    orderDetail,
    rawMenuData,
    loading,
    cartItems,
    isCartOpen,
    setIsCartOpen,
    cartSubTotal,
    cartTax,
    cartTotal,
    handleAddToCart,
    handleRemoveFromCart,
    handleUpdateInstruction,
    calulatePriceForMenu,
    instructionModalState,
    setInstructionModalState,
    handlePlaceOrder,
    handleDirectPrint,
    menuData,
    popularItems,
    customerOrder,
    handleUpdateCustomerInfo,
    isCustomerModalOpen,
    setIsCustomerModalOpen,
    isBranchConfirmModalOpen,
    setIsBranchConfirmModalOpen,
    isCardPaymentModalOpen,
    setIsCardPaymentModalOpen,
    cardPaymentStep,
    setCardPaymentStep,
    getPaymentTaxRate
  };
};
